import produce from 'immer'

import constants from 'constants/tools'

const initialState = {
  tools: [],
  allTools: [],
  fetching: false,
  doneFetching: false,
  fetchError: ''
}

export default produce((draft, action) => {
  switch (action.type) {
    case constants.FETCH_TOOLS_REQUEST:
      draft.fetching = true

      break

    case constants.FETCH_TOOLS_SUCCESS:
      draft.tools = action.tools
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = ''

      break

    case constants.FETCH_TOOLS_FAILURE:
      draft.fetchError = action.errorMessage
      draft.fetching = false
      draft.doneFetching = true

      break
    case constants.FETCH_ALL_TOOLS_REQUEST:
      draft.fetching = true
      break
    case constants.FETCH_ALL_TOOLS_SUCCESS:
      draft.allTools = action.allTools
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = ''
      break
    case constants.FETCH_ALL_TOOLS_FAILURE:
      draft.fetchError = action.errorMessage
      draft.fetching = false
      draft.doneFetching = true
      break
    case constants.RESET_TOOLS:
      return initialState
  }
}, initialState)
